import {Stack, Typography} from '@mui/material';
import React, {Fragment, useState} from 'react';

import {AlertInfo} from 'presentation/components';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';

import {translations} from 'presentation/translations-new';

import {CardAlertInfoProps} from './types';
import {StyledLink} from './styles';
import {SurgeryPrepareOrientations} from '../../../SurgeryPrepareOrientations';
import {PrepareModal} from '../../../PrepareModal';

const {appointmentCard} = translations['pt-br'].privateFlow.myAppointments;
const {bringDocument} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentDetails.appointmentInstructions;

export function InstructionsAlertInfo({
	bookingType,
	specialtyCode,
	specialtyName,
	...alertProps
}: CardAlertInfoProps) {
	const [openPrepareModalState, setOpenPrepareModalState] = useState(false);
	const [openSurgeryPrepareModal, setOpenSurgeryPrepareModal] = useState(false);

	const isExam = bookingType === BookingTypeEnum.EXAM;
	const isSurgery = bookingType === BookingTypeEnum.SURGERY;
	const showAlertInfo = isExam || isSurgery;

	const handleOpenInfoAlert = () => {
		return setOpenPrepareModalState(true);
	};

	const handleOpenSurgeryPrepareModal = () => {
		return setOpenSurgeryPrepareModal(true);
	};

	const examOrientations = (
		<Stack gap={1}>
			<Typography variant="body2">{appointmentCard.exam.description}</Typography>
			<StyledLink onClick={handleOpenInfoAlert}>{appointmentCard.exam.link}</StyledLink>
		</Stack>
	);

	const surgeryOrientations = (
		<Stack gap={1}>
			<Typography variant="body2">{appointmentCard.surgery.description}</Typography>
			<StyledLink onClick={handleOpenSurgeryPrepareModal}>
				{appointmentCard.surgery.link}
			</StyledLink>
		</Stack>
	);

	const description: Record<
		Exclude<BookingTypeEnum, BookingTypeEnum.TELEHEALTH>,
		React.ReactNode | string
	> = {
		[BookingTypeEnum.EXAM]: examOrientations,
		[BookingTypeEnum.HEALTH]: bringDocument,
		[BookingTypeEnum.ODONTO]: bringDocument,
		[BookingTypeEnum.SURGERY]: surgeryOrientations,
	};

	if (!showAlertInfo) {
		return null;
	}

	return (
		<Fragment>
			<AlertInfo.Root icon={false} {...alertProps}>
				<AlertInfo.Description>{description[bookingType]}</AlertInfo.Description>
			</AlertInfo.Root>

			{isExam && openPrepareModalState ? (
				<PrepareModal
					examNumber={String(specialtyCode)}
					setOpen={setOpenPrepareModalState}
					examName={specialtyName}
					open={openPrepareModalState}
				/>
			) : null}

			{isSurgery && openSurgeryPrepareModal ? (
				<SurgeryPrepareOrientations
					open={openSurgeryPrepareModal}
					setOpen={setOpenSurgeryPrepareModal}
				/>
			) : null}
		</Fragment>
	);
}
